import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMeasurements = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.18 15.035a1.75 1.75 0 0 1 0-2.475L12.277 2.462a1.75 1.75 0 0 1 2.474 0l3.075 3.075a1.75 1.75 0 0 1 0 2.475L7.729 18.11a1.75 1.75 0 0 1-2.475 0l-3.075-3.075Zm1.06-1.414a.25.25 0 0 0 0 .354l3.074 3.074a.25.25 0 0 0 .354 0L16.766 6.95a.25.25 0 0 0 0-.354l-3.074-3.074a.25.25 0 0 0-.354 0l-.962.962 1.998 1.998a.5.5 0 1 1-.707.707L11.67 5.192l-.835.835 1.05 1.05a.5.5 0 1 1-.707.708l-1.05-1.05-.716.715 1.998 1.998a.5.5 0 1 1-.707.707L8.704 8.157l-.836.836 1.051 1.05a.5.5 0 1 1-.707.708L7.162 9.7l-.716.716 1.997 1.997a.5.5 0 1 1-.707.707l-1.998-1.997-.835.835 1.05 1.051a.5.5 0 0 1-.706.707l-1.051-1.05z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMeasurements;
